import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import KendoDataSourceBase from '../KendoDataSourceBase'
import GanttDataSourceProps from './GanttDataSourceProps'

import Schema from './Schema'
import Filter from '../KendoDataSourceBase/Filter'
import Group from '../KendoDataSourceBase/Group'
import Sort from '../KendoDataSourceBase/Sort'
import Transport from '../KendoDataSourceBase/Transport'

export default {
    props: GanttDataSourceProps,
    mixins: [
        KendoBaseComponent, 
        KendoDataSourceBase,
        Filter,
        Group,
        Schema,
        Sort,
        Transport
    ],
    mounted() {
        this.kendoDataSource = new kendo.data.GanttDataSource(this.widgetOptions)
    },
    methods: {
        kendoWidget() {
            return this.kendoDataSource || new kendo.data.GanttDataSource(this.widgetOptions)
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoGanttDataSource/KendoGanttDataSourceMixin.js